import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderStatus,
} from "@/assets/js/utils";

/**** 处理工单数据** */
export function handleWrokOrderData(val) {
  let data = val;
  data.forEach((v) => {
    v.time = v.createdTime
      ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.createdTime))
      : "";
    v.handlers = v.assignStaffNames?.join("、");
    v.level = matchingOrderLevel(v.priority);
    v.imgInfo.forEach((item) => {
      if (item.imgUrl) {
        let httpUrl = window.jujiParams.baseURL;
        item.imgUrl = `${httpUrl}/${item.imgUrl}?tenant_id=${
          JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
        }`;
      }
    });
    v.setStatus = matchingOrderStatus(v.status);
  });
  return data;
}

/**** 处理巡检记录/保养记录数据** */
export function handleRecordTableData(val) {
  let data = val;
  data.forEach((v) => {
    v.planTime = `${dateFtt("yyyy-MM-dd hh:mm", new Date(v.begints))}-${dateFtt(
      "yyyy-MM-dd hh:mm",
      new Date(v.endts)
    )}`;
    v.point = `${v.done}/${v.total}`;
    let num = v.total == 0 ? 0 : (v.done / v.total) * 100;
    v.degreeNum = (Number.isInteger(num) ? num : num.toFixed(2)) + "%";
    v.planUser = v.handlers
      .map((item) => {
        return item.name;
      })
      .join(",");
    v.realityUser = v.truehandlers
      .map((item) => {
        return item.name;
      })
      .join(",");
  });
  return data;
}

/**** 处理登录相关接口返回错误匹配数据** */
export function handleLoginErrorToast(string) {
  let toast = "";
  switch (string) {
    case "image captcha error":
      toast = "图形验证码错误";
      break;
    case "captcha error":
      toast = "短信验证码验证错误";
      break;
    case "phone format error":
      toast = "手机号格式错误";
      break;
    case "phone not exist":
      toast = "手机号不存在";
      break;
    case "Phone does not exist":
      toast = "手机号不存在";
      break;
    case "recent sent":
      toast = "发送次数过于频繁,请稍后再试";
      break;
    case "cannot send message":
      toast = "无法发送短信,请联系管理员";
      break;
    case "Sms code doesn't match!":
      toast = "短信验证码验证错误";
      break;
    case "New password should be different from existing!":
      toast = "新密码不能与旧密码相同";
      break;
    case "new phone captcha error":
      toast = "新手机验证码错误";
      break;
    case "current phone captcha error":
      toast = "原手机验证码错误";
      break;
    default:
      toast = string;
  }
  return toast;
}

/**** 处理登录相关接口返回成功匹配数据** */
export function handleLoginSuccessToast(string) {
  let toast = "";
  switch (string) {
    case "success send sms": //短信验证码发送成功
      toast = "成功";
      break;
    case "success":
      toast = "成功";
      break;
    default:
      toast = "";
  }
  return toast;
}

export function handleCanvasTxt(str) {
  // 画布总宽度 px单位
  let canvasWidth = 150;
  // 字体大小 px单位
  let fontSize = 14;
  // 每行所需字数 = 画布总宽度 / 单个字体大小
  let rowFontNum = Math.floor(canvasWidth / fontSize);
  // 字符串总长度
  let strLength = str.length;
  // 所需行数 = 字符总长度 / 每行所需字数
  let rows = Math.ceil(strLength / rowFontNum);
  return { canvasWidth, fontSize, rowFontNum, strLength, rows };
}

/**** 匹配路由页面对应的权限字段** */
export function handleEditAuthority(path) {
  let string = "";
  switch (path) {
    case "/equipmentmanagement": //设备管理
      string = "shebei:equipmentmanagement:edit";
      break;
    case "/alarmManagement": //报警管理
      string = "shebei:alarmManagement:edit";
      break;
    case "/console": //照明-系统控制
      string = "zixitong:zhaoming:console:edit";
      break;
    case "/controls": //空调-系统控制
      string = "zixitong:kongtiao:controls:edit";
      break;
    case "/buildingInfor": //建筑信息
      string = "zixitong:jianzhu:buildingInfor:edit";
      break;
    case "/realTimeStatus": //动力-实时状态
      string = "zixitong:dongli:realTimeStatus:edit";
      break;
    case "/worksheets": //工单管理
      string = "houqinguanli:worksheets:edit";
      break;
    case "/patrolPoint": //巡检点位
      string = "houqinguanli:xunjianguanli:patrolPoint:edit";
      break;
    case "/patrolRoute": //巡检路线
      string = "houqinguanli:xunjianguanli:patrolRoute:edit";
      break;
    case "/patrolPlan": //巡检计划
      string = "houqinguanli:xunjianguanli:patrolPlan:edit";
      break;
    case "/equipmentMaintain": //设备信息
      string = "houqinguanli:baoyangguanli:equipmentMaintain:edit";
      break;
    case "/maintainPlan": //保养计划
      string = "houqinguanli:baoyangguanli:maintainPlan:edit";
      break;
    case "/authority": //权限管理
      string = "houqinguanli:authManager:edit";
      break;
    case "/historicalMonument": //项目历程
      string = "xiangmu:historicalMonument:edit";
      break;
    case "/projectInformation": //项目资讯
      string = "xiangmu:projectInformation:edit";
      break;
    case "/suggestions": //意见建议
      string = "xiangmu:suggestions:edit";
      break;
    default:
      string = "";
  }
  return string;
}
export function handleExportAuthority(path) {
  let string = "";
  switch (path) {
    case "/equipmentConsume": //能耗查询
      string = "nengyuan:equipmentConsume:export";
      break;
    case "/ebnormalEnergy": //异常用能
      string = "nengyuan:ebnormalEnergy:export";
      break;
    case "/addedEnergy": //新增用能
      string = "nengyuan:addedEnergy:export";
      break;
    case "/yoyAnalysis": //同比分析
      string = "nengyuan:yoyAnalysis:export";
      break;
    case "/ringAnalysis": //环比分析
      string = "nengyuan:ringAnalysis:export";
      break;
    case "/eCAnalysis": //能耗分析
      string = "nengyuan:eCAnalysis:export";
      break;
    case "/eCMeterReading": //用能集抄
      string = "nengyuan:eCMeterReading:export";
      break;
    case "/alarmManagement": //报警管理
      string = "shebei:alarmManagement:export";
      break;
    case "/alarmAnalysis": //报警分析
      string = "shebei:alarmAnalysis:export";
      break;
    case "/equipmentContrast": //设备对比
      string = "shebei:equipmentContrast:export";
      break;
    case "/systemDevice": //照明-系统设备
      string = "zixitong:zhaoming:systemDevice:export";
      break;
    case "/lightingEnergy": //照明-用能分析
      string = "zixitong:zhaoming:lightingEnergy:export";
      break;
    case "/airEnergy": //空调-用能分析
      string = "zixitong:kongtiao:airEnergy:export";
      break;
    case "/photovoltaicStation": //光伏电站
      string = "zixitong:guangfu:photovoltaicStation:export";
      break;
    case "/photovoltaicBenefits": //光伏效益
      string = "zixitong:guangfu:photovoltaicBenefits:export";
      break;
    case "/photovoltaicDevOps": //光伏-运维管理
      string = "zixitong:guangfu:photovoltaicDevOps:export";
      break;
    case "/distributingDevOps": //配电-运维管理
      string = "zixitong:peidian:distributingDevOps:export";
      break;
    case "/buildingInfor": //建筑信息
      string = "zixitong:jianzhu:buildingInfor:export";
      break;
    case "/dHWEnergy": //生活热水-用能分析
      string = "zixitong:shenghuoreshui:dHWEnergy:export";
      break;
    case "/dynamicalDevice": //动力-系统设备
      string = "zixitong:dongli:dynamicalDevice:export";
      break;
    case "/realTimeStatus": //动力-实时状态
      string = "zixitong:dongli:realTimeStatus:export";
      break;
    case "/dynamicalEnergy": //动力-用能分析
      string = "zixitong:dongli:dynamicalEnergy:export";
      break;
    case "/dynamicalDevOps": //动力-运维管理
      string = "zixitong:dongli:dynamicalDevOps:export";
      break;
    case "/energyReport": //能耗报表
      string = "baobiao:maintenanceReport:export";
      break;
    case "/devOpsReport": //运维报表
      string = "baobiao:devOpsReport:export";
      break;
    case "/customReport": //自定义报表
      string = "baobiao:customReport:export";
      break;
    case "/reportTemplate": //报表模板
      string = "baobiao:reportTemplate:export";
      break;
    case "/workOrderAnalysis": //工单分析
      string = "houqinguanli:workOrderAnalysis:export";
      break;
    case "/patrolPoint": //巡检点位
      string = "houqinguanli:xunjianguanli:patrolPoint:export";
      break;
    case "/patrolRoute": //巡检路线
      string = "houqinguanli:xunjianguanli:patrolRoute:export";
      break;
    case "/patrolPlan": //巡检计划
      string = "houqinguanli:xunjianguanli:patrolPlan:export";
      break;
    case "/patrolRecords": //巡检记录
      string = "houqinguanli:xunjianguanli:patrolRecords:export";
      break;
    case "/equipmentMaintain": //设备信息
      string = "houqinguanli:baoyangguanli:equipmentMaintain:export";
      break;
    case "/maintainPlan": //保养计划
      string = "houqinguanli:baoyangguanli:maintainPlan:export";
      break;
    case "/maintainRecords": //保养记录
      string = "houqinguanli:baoyangguanli:maintainRecords:export";
      break;
    case "/authority": //权限管理
      string = "houqinguanli:authManager:export";
      break;
    case "/systemDescription": //系统说明
      string = "xiangmu:systemDescription:export";
      break;
    case "/logManagement": //日志管理
      string = "rizhi:logManagement:export";
      break;
    default:
      string = "";
  }
  return string;
}
